import React from 'react';
import Spinner from '../Spinner/Spinner';
import {
  ChartBody,
  ChartCard,
  ChartHeader,
  ChartSubtitle,
  ChartTitle,
  EmptyState,
  SpinnerContainer,
} from './OrganizationAnalyticsChart.styles';

const OrganizationAnalyticsChartCard = ({ title, subtitle, pending, emptyText, hasData, children }) => {
  return (
    <ChartCard>
      <ChartHeader>
        <ChartTitle>{title}</ChartTitle>
        {subtitle ? <ChartSubtitle>{subtitle}</ChartSubtitle> : null}
      </ChartHeader>
      <ChartBody>
        {pending ? (
          <SpinnerContainer>
            <Spinner width={100} height={100} />
          </SpinnerContainer>
        ) : hasData ? (
          children
        ) : (
          <EmptyState>{emptyText}</EmptyState>
        )}
      </ChartBody>
    </ChartCard>
  );
};

export default OrganizationAnalyticsChartCard;
